module.exports = __webpack_public_path__ + "img/inventoryQuery.0ce88d31.png";